<script setup lang="ts">
import { useProductFilters } from '@/composables/useProductFilters'

import { CategoryPage } from '@/types/api/api-v4/category'
import { Factoid } from '@/types/main'

import CategoryFilters from '@/components/Category/CategoryFilters.vue'
import CategoryProductList from '@/components/Category/CategoryProductList.vue'

type Props = {
  currentCategory: CategoryPage
  isFilterActive?: boolean
  isLoading?: boolean
  templateFactoid?: Factoid | null
}

const props = withDefaults(defineProps<Props>(), {
  isFilterActive: true,
  templateFactoid: null,
})

const {
  isFiltersActivated,
  selectedFilters,
  possibleFilters,
  setActiveFilter,
  deactivateFilter,
  resetAllFilters,
  allProducts,
} = useProductFilters({
  products: props?.currentCategory.products,
})
</script>

<template>
  <category-filters
    v-if="currentCategory.tags?.length && isFilterActive"
    :filters="currentCategory.tags"
    :is-filters-activated="isFiltersActivated"
    :selected-filters="selectedFilters"
    :possible-filters="possibleFilters"
    @set-active-filter="setActiveFilter"
    @deactivate-filter="deactivateFilter"
    @reset-all-filters="resetAllFilters"
  />

  <category-product-list
    v-if="allProducts"
    :current-category="currentCategory"
    :filtered-products="allProducts"
    :template-factoid="templateFactoid"
    :is-loading="isLoading"
  />
</template>
